import { render } from "./Profile.vue?vue&type=template&id=9c5673c8"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
script.render = render

export default script